<!--
 * @Author: Lihao sun sunlihao.cosmo@haier.com
 * @Date: 2024-12-23 09:28:11
 * @LastEditors: Lihao sun sunlihao.cosmo@haier.com
 * @LastEditTime: 2024-12-23 10:06:18
 * @FilePath: src/components/workbench-design/render/index.vue
 * @Description: 这是默认设置,可以在设置》工具》File Description中进行配置
 -->
<!--
  @Author 22030124/xieyq
  @Date 2023-12-05 14:50:52
  @Description 工作台设计 =》渲染
-->
<template>
  <div
    :class="[scope.clsPrefix, { 'is-render-hover': renderHover }]"
    @mouseenter="renderHover = true"
    @mouseleave="renderHover = false"
  >
    <!-- 预览组件 -->
    <workbench-design-grid-layout :readonly="true" :data="data" />
  </div>
</template>

<script>
// 栅格布局
import WorkbenchDesignGridLayout from '../grid-layout/index.vue'
export default {
  // 组件名称
  name: 'WorkbenchDesignRender',
  components: {
    WorkbenchDesignGridLayout
  },
  props: {
    // 页面数据
    data: Object
  },
  // 数据
  data() {
    return {
      // 滚动容器是否处于鼠标悬浮状态，用于控制滚动条显隐
      renderHover: false,
      // 私有变量
      scope: {
        // class前缀
        clsPrefix: 'workbench-design-render'
      }
    }
  },
  // 创建完成
  created() {},
  // 方法
  methods: {}
}
</script>

<style lang="scss">
// 组件样式
$class-prefix: 'workbench-design-render';
.#{$class-prefix} {
  position: relative;
  height: 100%;
  overflow: auto;
  padding: 12px;
  // background: #F7F8FC;
  // 滚动条样式：默认隐藏，鼠标悬浮容器时显示
  // scrollbar-width/color 必须为 auto，否则 webkit 伪元素不生效
  scrollbar-width: auto;
  scrollbar-color: auto;
  &::-webkit-scrollbar {
    width: 10px !important;
    height: 10px !important;
  }
  &::-webkit-scrollbar-track {
    background: transparent;
    box-shadow: none;
    border: none;
  }
  // 轨道 10px，滑块视觉 8px：1px 透明边框把两侧各收进 1px
  &::-webkit-scrollbar-thumb {
    background-color: transparent !important;
    background-clip: padding-box !important;
    border: 1px solid transparent;
    border-radius: 5px !important;
    box-shadow: none !important;
  }
  // 由 JS 维护 class，规避 CSS :hover 在滚动到端点时的粘滞
  &.is-render-hover::-webkit-scrollbar-thumb {
    background-color: rgba(156, 167, 248, 0.2) !important;
    background-clip: padding-box !important;
    border: 1px solid transparent;
    border-radius: 5px !important;
  }
}
</style>
